export default __webpack_public_path__ + "static/media/ai-col-star.83e24144.svg";